import React, {Component} from 'react';
import DealroomProject from "./DealroomProject";

class DealroomProjects extends Component {



  render() {
    const {projects, removeChoosenProjects,onProjectChoose,choosenProjects} = this.props;

    return (
      <React.Fragment>
        <div style={{marginBottom: '20px'}}>
          <h3>Projects</h3>
          {projects.map((project, i) => {
            return (<div key={i}
                         style={{
                           display: 'flex',
                           alignItems: 'center',
                           justifyContent: 'space-between'
                         }}>

                <DealroomProject project={project}
                                 checkboxVal={choosenProjects.includes(i)}
                               projectIndex={i}
                                 removeChoosenProjects={removeChoosenProjects}
                               onProjectChoose={onProjectChoose}
                />
            </div>)
          })}
        </div>

      </React.Fragment>
    );
  }
}

export default DealroomProjects;


// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/DealroomProjects.js